<template>
	<section class="container mt-md-4 mt-3 mb-3 mb-md-5 item-list-compo info" v-if="isInfo">
			<a class="row info-box mt-2 mx-auto" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample" >
				<span itemprop="title" class="text font-weight-bold col-10">Infomation</span>
				<span class="col-2 text-right"><i class="far fa-plus-square"></i></span>
			</a>
		<div class="row justify-content-center">
			<div class="col-11 col-md-11 mx-auto mt-3">
				<p class="collapse" id="collapseExample" v-html="content"></p>
			</div>
		</div>
	</section>
</template>

<style>
	.info-box{
		border: 1px solid #B8B8B8;
		padding: 0.6rem;
	}
	@media(max-width: 768px){
		.info p{
			font-size: 0.7rem;
		}
		.info-box{
			font-size: 0.8rem;
		}
	}
</style>

<script>
	export default{
		data(){
			return{
				isInfo:false,
				content:'',
			}
		},
		created(){
			this.getJson()
		},
		methods:{
			async getJson(){
				await this.$axios
				.get(this.$uri+'?type=infomation')
				.then((response) => {
					this.content = response.data.infomation_list[0].content
					this.isInfo = response.data.infomation_list[0].display
				})
				.catch(() => {
				})
			},
		}
	}
</script>